// ./context/student/studentInitialState.js

export default {
    studentData: null,
    enrolledCourses: [],
    completedCourses: [],
    labSubmissions: [],
    quizSubmissions: [],
    examSubmissions: [],
    capstoneSubmissions: [],
    achievements: [],
    notifications: [],
    learningPath: null,
    labProgress: null,
    quizProgress: null,
    examProgress: null,
    capstoneProgress: null,
    courseGrade: null,
    allGrades: [],
    calculatedGrade: null,
    courseProgress: null,
    cart: [],
    paymentHistory: [],
    lastPayment: null,
    isLoading: false,
    error: null
}